import DesignName from './DesignName';

export default DesignName;
